<button
  (click)="openTab(tab)"
  mat-flat-button
  class="btn-gray"
  *ngFor="let tab of tabs"
  [ngClass]="{ active: tabsService.getActiveTab() === tab }"
>
  {{ tab.title }}<span (click)="closeTab(tab)" class="exit">x</span>
</button>
